import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';  ///----------- for searching pop up -----------
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { MatDialog } from '@angular/material/dialog';
 



@Component({
  selector: 'app-tnmclass-line',
  templateUrl: './tnmclass-line.component.html',
  styleUrls: ['./tnmclass-line.component.css']
})
export class TNMClassLineComponent implements OnInit {
  visdate = formatDate(new Date(), 'yyyy-MM-dd', 'en');
  vism ='0';
  visn ='0';
  vist ='0';
  visgrade = '0';
  visstage = '0';
  vissite ='';
  visfamily ='';
  @Output() submitClicked = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

}
